import '../scss/main.scss';
import { initMobileNav } from './modules/mobile-nav.js';
import { initStickyHeader } from './modules/sticky-header.js';
import { initAccordionTeasers } from './modules/accordion-teaser.js';
import { initContactForms } from './modules/contact-form.js';
import { initScrollReveal } from './modules/scroll-reveal.js';
import { initTeamPopups } from './modules/team-popup.js';
import { initProductFilters } from './modules/product-filter.js';
import { initCookieNotice } from './modules/cookie-consent.js';

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initStickyHeader();
  initAccordionTeasers();
  initContactForms();
  initScrollReveal();
  initTeamPopups();
  initProductFilters();
  initCookieNotice();
});
